'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _decko = require('decko');

var _observable = require('./observable');

var _observable2 = _interopRequireDefault(_observable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var LiveElement = (_class = function (_Observable) {
  _inherits(LiveElement, _Observable);

  /**
   * Creates an instance of LiveElement.
   *
   * @param {string}      selector
   * @param {HTMLElement} parent
   */
  function LiveElement(selector) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, LiveElement);

    var _this = _possibleConstructorReturn(this, (LiveElement.__proto__ || Object.getPrototypeOf(LiveElement)).call(this, selector, parent, config));

    _this.item = null;


    if (_this.parent) {
      _this.item = _this.parent.querySelector(_this.selector);
    }

    _this.registerDOMObserver();
    return _this;
  }

  /**
   * Proxy for Element.addEventListener
   *
   * @param {string}   event
   * @param {function} callback
   * @param {boolean}  passive
   */

  /**
   * The underlying element
   *
   * @type {HTMLElement}
   */


  _createClass(LiveElement, [{
    key: 'addEventListener',
    value: function addEventListener(event, callback) {
      var passive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!(event in this.eventListeners)) {
        this.eventListeners[event] = [];
      }

      this.eventListeners[event].push(callback);

      if (this.item) {
        this.item.addEventListener(event, callback);
      }

      this.events['eventListeners:add'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Proxy for Element.removeEventListener
     *
     * @param {string}   event
     * @param {function} callback
     */

  }, {
    key: 'removeEventListener',
    value: function removeEventListener(event, callback) {
      if (event in this.eventListeners) {
        var i = this.eventListeners[event].indexOf(callback);
        if (i > -1) {
          this.eventListeners[event].splice(i, 1);
        }
      }

      if (this.item) {
        this.item.removeEventListener(event, callback);
      }

      this.events['eventListeners:remove'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Attach all event listeners to the underlying element
     *
     * @param {Element} item
     */

  }, {
    key: 'attachEventListeners',
    value: function attachEventListeners() {
      var _this2 = this;

      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.item;

      if (!item) {
        return;
      }

      if (!(item instanceof Element)) {
        throw new TypeError('item must be an instance of Element');
      }

      Object.keys(this.eventListeners).forEach(function (event) {
        _this2.eventListeners[event].forEach(function (callback) {
          item.addEventListener(event, callback);
        });
      });

      this.events['eventListeners:attach'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Detach all event listeners from the underlying element
     *
     * @param {Element} item
     */

  }, {
    key: 'detachEventListeners',
    value: function detachEventListeners() {
      var _this3 = this;

      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.item;

      if (!item) {
        return;
      }

      if (!(item instanceof Element)) {
        throw new TypeError('item must be an instance of Element');
      }

      Object.keys(this.eventListeners).forEach(function (event) {
        _this3.eventListeners[event].forEach(function (callback) {
          item.removeEventListener(event, callback);
        });
      });

      this.events['eventListeners:detach'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Refreshes the attached element
     */

  }, {
    key: 'refresh',
    value: function refresh() {
      var current = this.item;
      var selected = this.parent.querySelector(this.selector);

      if (current !== selected) {
        this.detachEventListeners(current);
        this.attachEventListeners(selected);

        this.item = selected;

        this.events.update.forEach(function (callback) {
          return callback(selected, current);
        });
      }

      if (this.item) {
        this.attachDelegatedEventListeners();
      } else {
        this.detachDelegatedEventListeners();
      }
    }
  }]);

  return LiveElement;
}(_observable2.default), (_applyDecoratedDescriptor(_class.prototype, 'addEventListener', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'addEventListener'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeEventListener', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'removeEventListener'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'attachEventListeners', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'attachEventListeners'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'detachEventListeners', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'detachEventListeners'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'refresh', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'refresh'), _class.prototype)), _class);
exports.default = LiveElement;
//# sourceMappingURL=live-element.js.map